export const items = [
  {
    title: "Preventative & seasonal maintenance",
    content:
      "Your home’s upkeep & improvement needs are unique. In our app, we create a tailored maintenance plan that has you covered for all maintenance and proactive care.",
    link: { label: "View sample seasonal maintenance plan here.", to: "/read" }
  },
  {
    title: "Marketplace of pre-vetted vendors",
    content:
      "Our vetted and curated list of service pros are available to you 24/7 — we will diagnose and pair your with the right service pro to get the job done.",
    link: { label: "View all of our services here. ", to: "/read" }
  },
  {
    title: "Trusted handymen services",
    content:
      "Our trained Handymen can do everything from mounting a tv to fixing a fence (if needed).",
    link: { label: "View a list things your handyman can do.", to: "/read" }
  }
];
